/**
 * Meta Ads and Google Ads — the storefront half of the contract, zod-free so
 * traveler-web can import it without pulling zod into the browser bundle
 * (the same split as `posthog-storefront.ts`).
 *
 * The page reports a traveler moment by pushing an {@link AdsStorefrontEvent}
 * onto `window[ADS_EVENT_QUEUE_GLOBAL]` and dispatching {@link ADS_EVENT_NAME}.
 * Each ads app's inline script (`ads-scripts.ts`) reads the whole queue, so a
 * moment pushed before the script ran is still sent.
 */

import type { AdsTrackedEvent } from "./ads";

/** The apps that turn on ad-click capture and the ads consent question. */
export const ADS_APP_SLUGS = ["meta-ads", "google-ads"] as const;

export const isAdsAppSlug = (slug: string): boolean =>
  (ADS_APP_SLUGS as readonly string[]).includes(slug);

export const ADS_EVENT_QUEUE_GLOBAL = "__tcAdsEvents";
export const ADS_EVENT_NAME = "tc:ads-event";

/**
 * Cookie Consent sets this to `true` when it asks for ads consent. The ads
 * scripts then load only once the visitor accepts (AC-09).
 */
export const ADS_CONSENT_REQUIRED_GLOBAL = "__tcAdsConsentRequired";
export const ADS_CONSENT_COOKIE = "tc_ads_consent";
export const ADS_CONSENT_EVENT_NAME = "tc:ads-consent";

export interface AdsStorefrontEvent {
  name: AdsTrackedEvent;
  /** The booking or inquiry id. Meta and Google use it to drop the copy the
   *  server sends for the same moment (AC-10). */
  eventId?: string;
  /** Major units, as both vendors expect. */
  value?: number;
  currency?: string;
  /** The tour id. */
  contentId?: string;
}
